import { render } from "./sclfdzHome.vue?vue&type=template&id=685f59d8"
import script from "./sclfdzHome.vue?vue&type=script&lang=js"
export * from "./sclfdzHome.vue?vue&type=script&lang=js"

import "./sclfdzHome.vue?vue&type=style&index=0&id=685f59d8&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__